import { t } from 'i18next';

export const getTranslatedInitialValue = (title: string) => {
  switch (title) {
    case 'Gross Margin':
      return t('pdfPages.mappings.financialPlan.profitabilityRatiosTable.grossMargin');
    case 'Net Profit Margin':
      return t('pdfPages.mappings.financialPlan.profitabilityRatiosTable.netProfitMargin');
    case 'Net Profit':
      return t('pdfPages.mappings.financialPlan.profitabilityRatiosTable.netProfit');
    case 'Current Ratio':
      return t('pdfPages.mappings.financialPlan.liquidityRatiosTable.currentRatio');
    case 'Quick Ratio':
      return t('pdfPages.mappings.financialPlan.liquidityRatiosTable.quickRatio');
    case 'Inventory turnover ratio':
      return t('pdfPages.mappings.financialPlan.efficiencyRatiosTable.inventoryRatio');
    case 'Accounts receivable turnover ratio':
      return t('pdfPages.mappings.financialPlan.efficiencyRatiosTable.accountsReceivableRatio');
    case 'Accounts payable turnover ratio':
      return t('pdfPages.mappings.financialPlan.efficiencyRatiosTable.accountsPayableRatio');
    case 'Non-current assets turnover ratio':
      return t('pdfPages.mappings.financialPlan.efficiencyRatiosTable.nonCurrentAssetsRatio');
    case 'Debt to equity ratio':
      return t('pdfPages.mappings.financialPlan.solvencyRatiosTable.debtToEquityRatio');
    case 'Total assets to equity ratio':
      return t('pdfPages.mappings.financialPlan.solvencyRatiosTable.totalAssetsToEquityRatio');
    case 'Total assets to total liabilities ratio':
      return t('pdfPages.mappings.financialPlan.solvencyRatiosTable.totalAssetsToTotalLiabilitiesRatio');
    case 'Capitalization ratio':
      return t('pdfPages.mappings.financialPlan.solvencyRatiosTable.capitalizationRatio');
    case 'Interest coverage ratio':
      return t('pdfPages.mappings.financialPlan.solvencyRatiosTable.interestCoverageRatio');
    case 'Own funds':
      return t('financialPlan.cashFlowElements.calendarPlan.ownFunds');
    case 'Borrowed funds':
      return t('financialPlan.cashFlowElements.calendarPlan.borrowedFunds');
    case 'Investment funds':
      return t('financialPlan.cashFlowElements.calendarPlan.investmentFunds');
    case 'Repayment of loan':
      return t('financialPlan.cashFlowElements.loanRepaymentSchedule.repaymentOfLoan');
    case 'Interest payment':
      return t('financialPlan.cashFlowElements.loanRepaymentSchedule.interestPayment');
    case 'Cost of sales (variable)':
      return t('pdfPages.mappings.financialPlan.totalExpensesForm.costOfSalesVariable');
    case 'Cost of sales (fixed)':
      return t('pdfPages.mappings.financialPlan.totalExpensesForm.costOfSalesFixed');
    case 'Research and development (R&D)':
      return t('pdfPages.mappings.financialPlan.totalExpensesForm.researchAndDevelopmentRandD');
    case 'Sales and marketing':
      return t('pdfPages.mappings.financialPlan.totalExpensesForm.salesAndMarketing');
    case 'General and administrative':
      return t('pdfPages.mappings.financialPlan.totalExpensesForm.generalAndAdministrative');
    case 'Other operating expenses':
      return t('pdfPages.mappings.financialPlan.totalExpensesForm.otherOperatingExpenses');
    case 'Financial expenses':
      return t('pdfPages.mappings.financialPlan.totalExpensesForm.financialExpenses');
    case 'Non-operating expenses':
      return t('pdfPages.mappings.financialPlan.totalExpensesForm.nonOperatingExpenses');
    case 'Production employees (fixed expenses)':
      return t('pdfPages.mappings.financialPlan.personnelExpensesRows.productionEmployeesFixedExpenses');
    case 'Production employees (variable expenses)':
      return t('pdfPages.mappings.financialPlan.personnelExpensesRows.productionEmployeesVariableExpenses');
    case 'Administrative staff':
      return t('pdfPages.mappings.financialPlan.personnelExpensesRows.administrativeStaff');
    case 'Marketing and sales personnel':
      return t('pdfPages.mappings.financialPlan.personnelExpensesRows.marketingAndSalesPersonnel');
    case 'R&D staff':
      return t('pdfPages.mappings.financialPlan.personnelExpensesRows.rndStaff');
    case 'Number of Employees':
      return t('pdfPages.mappings.financialPlan.personnelExpensesColumns.numberOfEmployees');
    case 'Average monthly salary':
      return t('pdfPages.mappings.financialPlan.personnelExpensesColumns.averageMonthlySalary');
    case 'Total monthly payroll expenses':
      return t('pdfPages.mappings.financialPlan.personnelExpensesColumns.totalMonthlyPayrollExpenses');
    case 'Annual expense growth rate, %':
      return t('pdfPages.mappings.financialPlan.personnelExpensesColumns.annualExpenseGrowthRatePercent');
    case 'R&D':
      return t('financialPlan.cashFlowElements.fundingDirections.rAndD');
    case 'Marketing and Sales':
      return t('financialPlan.cashFlowElements.fundingDirections.marketingAndSales');
    case 'Working Capital':
      return t('financialPlan.cashFlowElements.fundingDirections.workingCapital');
    case 'Construction':
      return t('financialPlan.cashFlowElements.fundingDirections.construction');
    case 'Equipment Purchase':
      return t('financialPlan.cashFlowElements.fundingDirections.equipmentPurchase');
    case 'Other':
      return t('financialPlan.cashFlowElements.fundingDirections.other');

    case 'Salaries for production staff':
      return t('pdfPages.mappings.financialPlan.costOfSalesForm.salariesForProductionStaff');
    case 'Benefits and payroll taxes for production staff':
      return t('pdfPages.mappings.financialPlan.costOfSalesForm.benefitsAndPayrollTaxesForProductionStaff');
    case 'Depreciation of fixed assets':
      return t('pdfPages.mappings.financialPlan.costOfSalesForm.depreciationOfFixedAssets');
    case 'Amortization of Intangible Assets':
      return t('pdfPages.mappings.financialPlan.costOfSalesForm.amortizationOfIntangibleAssets');

    case 'Salaries and commissions for sales staff':
      return t('pdfPages.mappings.financialPlan.salesAndMarketingForm.salariesAndCommissionsForSalesStaff');
    case 'Benefits and payroll taxes for sales staff':
      return t('pdfPages.mappings.financialPlan.salesAndMarketingForm.benefitsAndPayrollTaxesForSalesStaff');

    case 'Salaries and wages for executive, administrative, and support staff':
      return t(
        'pdfPages.mappings.financialPlan.generalAndAdministrativeForm.salariesAndWagesForExecutiveAdministrativeAndSupportStaff',
      );
    case 'Benefits and payroll taxes for administrative staff':
      return t(
        'pdfPages.mappings.financialPlan.generalAndAdministrativeForm.benefitsAndPayrollTaxesForAdministrativeStaff',
      );

    case 'Salaries for researchers and developers':
      return t('pdfPages.mappings.financialPlan.randDForm.salariesForResearchersAndDevelopers');
    case 'Benefits and payroll taxes for researchers and developers':
      return t('pdfPages.mappings.financialPlan.randDForm.benefitsAndPayrollTaxesForResearchersAndDevelopers');

    default:
      return title;
  }
};
